var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75C10.1331 3.75 8.66669 5.20257 8.66669 6.9375C8.66669 8.67243 10.1331 10.125 12 10.125C13.8669 10.125 15.3334 8.67243 15.3334 6.9375C15.3334 5.20257 13.8669 3.75 12 3.75ZM7.16669 6.9375C7.16669 4.32319 9.35659 2.25 12 2.25C14.6435 2.25 16.8334 4.32319 16.8334 6.9375C16.8334 9.55181 14.6435 11.625 12 11.625C9.35659 11.625 7.16669 9.55181 7.16669 6.9375ZM14.6662 14.9684C12.8999 14.6772 11.1001 14.6772 9.33382 14.9684L9.12605 15.0027L9.00404 14.2627L9.12604 15.0027C7.19882 15.3204 5.75 17.0477 5.75 19.1115C5.75 19.7634 6.25549 20.25 6.82813 20.25H17.1719C17.7445 20.25 18.25 19.7634 18.25 19.1115C18.25 17.0477 16.8012 15.3204 14.874 15.0027L14.996 14.2627L14.874 15.0027L14.6662 14.9684ZM14.9102 13.4884L14.7882 14.2284L14.9102 13.4884L15.118 13.5226C17.8042 13.9655 19.75 16.349 19.75 19.1115C19.75 20.5455 18.6185 21.75 17.1719 21.75H6.82813C5.38147 21.75 4.25 20.5455 4.25 19.1115C4.25 16.349 6.19583 13.9655 8.88203 13.5226L9.08981 13.4884L9.21182 14.2284L9.08982 13.4884C11.0177 13.1705 12.9823 13.1705 14.9102 13.4884Z",
    fill: "#E01A4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.bf90c0f6a8113d85dfbcca00d85b2fb2.svg";
export { ForwardRef as ReactComponent };